export default {
  defaultProps: {
    elevation: 3,
  },
};
